<template>
    <v-layout row wrap px-2>
        <v-flex class="pb-1 d-flex justify-space-between " lg12 md12 sm12>
            <confirmation-header-text class="ml-2"
                                      icon="mdi-account-box"
                                      text="Personal Details"/>
            <v-btn
                @click="viewHistory(traveller)"
                color="primary"
                dark
                dense
                small
                text
                v-if="traveller.id">
                View Details
            </v-btn>
            <v-tooltip top v-if="!traveller.id">
                <template v-slot:activator="{ on }">

                    <v-btn
                        @click="editTraveller(traveller)"
                        v-if="!isVerified"
                        class="mr-2"
                        color="#FF8316"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                    >
                        <v-icon small>edit</v-icon>
                    </v-btn>
                </template>
                <span>Update Traveller Information</span>
            </v-tooltip>
        </v-flex>
        <v-flex md3 xs12 class="pl-3">
            <list-item-detail :sub_title="traveller.full_name"
                              title="Name"/>
        </v-flex>
        <v-flex md3 xs12>
            <list-item-detail :sub_title="traveller.country_name || traveller.country.country_name"
                              title="Country"/>
        </v-flex>

        <v-flex md3 xs12>
            <list-item-detail :sub_title="traveller.dob + ' (' + traveller.age + ' )'"
                              title="Date of Birth (Age)"/>
        </v-flex>

        <v-flex sm3 xs12>
            <file-list-item-detail :avatar="true"
                                   :src="traveller.image"
                                   sub_title="User Image">
            </file-list-item-detail>
        </v-flex>


        <v-flex md3 sm4 xs6 class="pl-3">
            <list-item-detail :sub_title="traveller.gender"
                              title="Gender">
            </list-item-detail>
        </v-flex>

        <v-flex md3 sm4 xs6>
            <list-item-detail :sub_title="traveller.occupation && traveller.occupation.name ? traveller.occupation.name : traveller.occupation"
                              title="Occupation">
            </list-item-detail>
        </v-flex>

        <v-flex md3 sm4 xs6>
            <list-item-detail :sub_title="traveller.full_address" :show-tooltip="true"
                              :title="'Address  of ' +(traveller.country_name || traveller.country.country_name)">
            </list-item-detail>
        </v-flex>
        <v-flex sm3 xs12>
            <list-item-detail :sub_title="traveller.email"
                              title="Email Address">
            </list-item-detail>
        </v-flex>

        <v-flex sm3 xs12 class="pl-3">
            <list-item-detail :sub_title="traveller.contact_number"
                              :title="'Contact Number of '+(traveller.country_name || traveller.country.country_name)">
            </list-item-detail>
        </v-flex>
        <v-flex sm3 xs12 v-if="mobile_number">
            <list-item-detail :sub_title="mobile_number"
                              title="Mobile number">
            </list-item-detail>
        </v-flex>

        <v-dialog
            persistent
            transition="dialog-bottom-transition"
            v-if="$oauth.checkIfHasPermission(['alter traveller-details']) && !isVerified"
            v-model="travellerDialog"
            width="700">
            <v-card>
                <v-toolbar color="blue darken-3" dark>
                    <v-toolbar-title>Edit Traveller</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-0">
                    <v-container grid-list-md class="pb-0">
                        <v-layout wrap>
                            <form-error-display-handler :errors="errors" v-if="errors"/>
                            <v-flex xs12>
                                <v-form class="pa-2" lazy-validation ref="formRef">
                                    <v-flex xs12 class="px-0">
                                        <v-text-field
                                            label="Full Name *"
                                            :rules="[rules.required]"
                                            outlined
                                            type="text"
                                            v-model="traveller.full_name"
                                            id="fullName"
                                        />
                                    </v-flex>
                                    <v-layout wrap class="pa-0">
                                        <v-flex xs6>
                                            <v-select
                                                :items="genders"
                                                label="Gender *"
                                                :rules="[rules.required]"
                                                outlined
                                                v-model="traveller.gender"
                                                id="gender"
                                            />
                                        </v-flex>

                                        <v-flex xs6>
                                            <v-text-field
                                                label="Date of Birth *"
                                                :rules="[rules.required,rules.dobValidityDate]"
                                                outlined
                                                type="date"
                                                v-model="traveller.dob"
                                                id="dob"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout wrap>
                                        <v-flex xs6>
                                            <v-combobox
                                                :items="occupationList"
                                                label="Occupation *"
                                                :rules="[rules.required]"
                                                outlined
                                                v-model="traveller.occupation"
                                                id="occupation"
                                            />
                                        </v-flex>


                                        <v-flex xs6>
                                            <v-text-field
                                                :label="'Contact Number of '+traveller.country_name+' *'"
                                                :rules="[rules.required]"
                                                min="0"
                                                outlined
                                                type="number"
                                                v-model="traveller.contact_number"
                                                id="contactNumber"
                                            />
                                        </v-flex>
                                    </v-layout>

                                    <v-flex xs12 class="px-0">
                                        <v-text-field
                                            label="Email"
                                            :rules="[rules.email]"
                                            outlined
                                            type="email"
                                            v-model="traveller.email"
                                            id="email"
                                        />
                                    </v-flex>
                                    <v-flex
                                        xs12
                                        class="px-0">

                                        <file-input
                                            placeholder="JPEG, JPG or PNG only"
                                            :valid_file_types="['png', 'jpeg', 'jpg']"
                                            label="Passport Size Image"
                                            v-model="display_image"
                                            :image-url="traveller.image"
                                            id="userImage"
                                            :fileSize="2048"
                                        />
                                    </v-flex>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        @click="travellerDialog=false"
                        class="white--text"
                        color="red lighten-1"
                    >Cancel
                    </v-btn>
                    <v-btn
                        :loading="loading"
                        @click="updateTraveller"
                        class="white--text"
                        color="blue darken-3"
                    >Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import ListItemDetail from '../../../components/ListItemDetail';
    import FileListItemDetail from '../../../components/FileListItemDetail';
    import ConfirmationHeaderText from '../../../components/ConfirmationHeaderText';
    import FormErrorDisplayHandler from '../../../components/FormErrorDisplayHandler';
    import {validationMixin} from '../../../mixins/validationMixin';
    import FileInput from '../../../components/FileInput';

    import {API_URL, VERSION} from "../../../config/config";
    import Http from "axios";

    export default {
        name: "TravellerDetail",
        components: {
            ListItemDetail,
            ConfirmationHeaderText,
            FileListItemDetail,
            FormErrorDisplayHandler,
            FileInput,
        },
        mixins: [validationMixin],
        props: ['mobile_number'],
        data() {
            return {
                loading: false,
                travellerDialog: false,
                errors: [],
                genders: ['Male', 'Female', 'Others'],
                occupationList: [],
                display_image: null
            }
        },
        computed: {
            traveller() {
                return this.$store.state.VisaRequestSingle.visaRequest.traveller;
            },
            isVerified() {
                return this.$store.state.VisaRequestSingle.visaRequest.isVerified;
            },
            visaTraveller() {
                let visa = this.$store.state.VisaRequestSingle.visaRequest;
                let traveller = visa.traveller;
                if(visa.extra.application_data && visa.extra.application_data.traveller)
                    traveller = visa.extra.application_data.traveller;
                return traveller;
            }
        },
        methods: {

            viewHistory(item) {
                window.open('/admin/system/travellers-history/view/' + item.id, '_blank');
            },
            editTraveller() {
                this.fetchOccupations();
                this.travellerDialog = true;
            },

            fetchOccupations() {
                try {
                    Http.get(`${API_URL}${VERSION}` + '/dynamic-values-setup/fetch-all', {
                        params: {
                            key: 'occupations',
                        }
                    }).then((response) => {
                        let items = response.data.map((item) => item.value);
                        items = items.map(i => i.name);
                        items.push('Others');
                        this.occupationList = items;
                    })
                } catch (e) {
                    throw e;
                }
            },
            updateTraveller() {

                let formData = new FormData();
                formData.set("full_name", this.traveller.full_name);
                formData.set("dob", this.traveller.dob);
                formData.set("gender", this.traveller.gender);
                formData.set("occupation", this.traveller.occupation);
                formData.set("contact_number", this.traveller.contact_number);
                formData.set("email", this.traveller.email);
                if (this.display_image)
                    formData.set("image", this.display_image);
                let id = this.$store.state.VisaRequestSingle.visaRequest.id;
                Http.post(`${API_URL}${VERSION}/visa-requests/traveller/${id}/update`, formData
                )
                    .then(() => {
                        this.$store.commit('Notification/showSuccess', 'Traveller Detail Updated Successfully');
                        this.travellerDialog = false;
                    })
                    .catch((er) => {
                            this.errors = er.response.data.errors;
                            this.$store.commit('Notification/showError', 'Something went wrong');
                        }
                    );
            },
        }
    }
</script>

<style scoped>

</style>
